var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoCallStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.5647 24 24 18.5647 24 12C24 5.44706 18.5529 0 11.9882 0C5.43529 0 0 5.44706 0 12C0 18.5647 5.44706 24 12 24ZM6.92941 16.8941C5.71765 16.8941 5 16.1882 5 15V9.02353C5 7.81176 5.76471 7.11765 6.92941 7.11765H13.4C14.6235 7.11765 15.2588 7.81176 15.2588 9.02353V15C15.2588 16.1882 14.5529 16.8941 13.3412 16.8941H6.92941ZM15.9412 13.6588V10.3529L18.3176 8.32941C18.5176 8.16471 18.7765 8.04706 18.9882 8.04706C19.4471 8.04706 19.7529 8.37647 19.7529 8.88235V15.1294C19.7529 15.6471 19.4471 15.9765 18.9882 15.9765C18.7765 15.9765 18.5294 15.8588 18.3176 15.6824L15.9412 13.6588Z",
    fill: "#00872A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallStart);
export default __webpack_public_path__ + "static/media/VideoCallStart.80dda7e5f2c2b73f0a4f9f5013428675.svg";
export { ForwardRef as ReactComponent };